import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({ name: 'isBefore' })
export class IsBeforePipe implements PipeTransform {
  transform(date: string | null, format = 'YYYY-MM-DD HH:mm:ss'): boolean {
    if (date) {
      return moment(date, format).isBefore(moment());
    }
    return true;
  }
}

@Pipe({
  name: 'isFutureDate',
})
export class IsFutureDatePipe implements PipeTransform {
  transform(value: string | null): boolean {
    if (!value) {
      return false;
    }
    const date = moment(value);
    if (!date.isValid()) {
      return false;
    }
    return date.isAfter(moment());
  }
}

@Pipe({
  name: 'isPastDate',
})
export class IsPastDatePipe implements PipeTransform {
  transform(date: string | null, format = 'YYYY-MM-DD HH:mm:ss'): boolean {
    if (date) {
      return moment(date, format).isBefore(moment());
    }
    return true;
  }
}
